import { render, staticRenderFns } from "./BaseProductSeriesConfigurations.vue?vue&type=template&id=e3a5e51c&scoped=true"
import script from "./BaseProductSeriesConfigurations.vue?vue&type=script&lang=js"
export * from "./BaseProductSeriesConfigurations.vue?vue&type=script&lang=js"
import style0 from "./BaseProductSeriesConfigurations.vue?vue&type=style&index=0&id=e3a5e51c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a5e51c",
  null
  
)

export default component.exports